import React, { useState } from "react";
import { Link } from "react-router-dom";
import { adminApi, formatApiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { LangToggle } from "@/components/LangToggle";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminForgot() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await adminApi.post("/auth/forgot-password", { email });
      setMsg(r.data.message || "If that email is registered, a reset link has been sent.");
    } catch (err) {
      setMsg(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/login"><img src="/corp-logo.png" alt="Relax-MIS" className="h-10 w-auto" /></Link>
          <LangToggle variant="light" />
        </div>
      </header>
      <main className="max-w-md mx-auto px-6 py-16">
        <div className="rounded-xl border border-stone-200 shadow-sm p-8 bg-white">
          <h1 className="font-serif text-3xl text-stone-900 mb-2">Reset password</h1>
          <p className="text-stone-500 text-sm mb-4">Enter your admin email — if it exists we'll send a reset link.</p>
          <form onSubmit={submit} className="space-y-4">
            <Input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email"
              required
            />
            <Button
              type="submit"
              disabled={busy}
              className="w-full bg-emerald-800 hover:bg-emerald-900 text-amber-50"
              data-testid="forgot-submit"
            >
              {busy ? "…" : "Send reset link"}
            </Button>
          </form>
          {msg && <div className="mt-4 text-stone-700 text-sm" data-testid="forgot-message">{msg}</div>}
          <div className="text-center mt-4">
            <Link to="/login" className="text-emerald-800 text-sm hover:text-emerald-900 underline underline-offset-4" data-testid="forgot-back-link">
              Back to sign in
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
